/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_EMPLOYEES_QUERY } from "../../graphql/Employees/Employees.graphql";

function EmployeeSelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  readOnly,
  required,
  disabled,
  disableInActive = false
}) {
  const { data, loading, error } = useQuery(ALL_EMPLOYEES_QUERY, { variables });

  const employees = data?.Employees || [];
  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : ""
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly || disabled}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {employees.map((Employee, i) => (
              <Select.Option
                disabled={disableInActive && !Employee.Active}
                key={`employee-select-${i}`}
                value={Employee.RecId}
              >
                {Employee.LastName}, {Employee.FirstName}
              </Select.Option>
            ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

EmployeeSelect.propTypes = {
  value: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  disableInActive: PropTypes.bool,
  disabled: PropTypes.bool
};

EmployeeSelect.defaultProps = {
  variables: { where: { Active: true }, orderByMulti: ["LastName_ASC"] }
};
export default EmployeeSelect;
